/* ==========================================================================
   NAJIBS — editorial parallax
   Owns <najibs-parallax> for sections/editorial-campaign.liquid. Browsers that
   support scroll-driven CSS animations do the whole thing in CSS and this file
   stands down; everywhere else a single IntersectionObserver + rAF sets one
   custom property. Reduced motion switches both paths off. Loaded with defer
   from the section, so the theme editor re-runs the element's own lifecycle on
   every re-render.
   ========================================================================== */
(function () {
  if (customElements.get('najibs-parallax')) return;

  const SUPPORTS_CSS_TIMELINE =
    typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: view()');
  const TRAVEL = 20;

  class NajibsParallax extends HTMLElement {
    connectedCallback() {
      if (this.dataset.parallax !== 'true') return;
      if (SUPPORTS_CSS_TIMELINE) return;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motionQuery.matches) return;

      this.ticking = false;
      this.visible = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visible = entry.isIntersecting;
          });
          if (this.visible) this.request();
        },
        { rootMargin: '15% 0px' }
      );
      this.observer.observe(this);

      this.onScroll = () => {
        if (this.visible) this.request();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => this.update());
    }

    update() {
      this.ticking = false;
      const rect = this.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight || 1;
      const centre = rect.top + rect.height / 2 - viewport / 2;
      const span = Math.max(1, viewport / 2 + rect.height / 2);
      const progress = Math.max(-1, Math.min(1, centre / span));
      this.style.setProperty('--parallax-y', (progress * TRAVEL).toFixed(2) + 'px');
      this.style.setProperty('--parallax-y-2', (progress * TRAVEL * -0.6).toFixed(2) + 'px');
    }
  }

  customElements.define('najibs-parallax', NajibsParallax);
})();
